<template>
  <div>
    <div class="page-wrapper profile-summary" style="padding-top: 0px">
      <div class="container">
        <div class="top-wrap">
          <div class="page-heading">
            <h1 class="page-title">{{ college.collegeName }}</h1>
            <div class="extra-view">
              <a-button
                type="primary"
                icon="usergroup-add"
                v-if="
                  !this.$route.params.id &&
                  (onlyCollegeHeadCoach() || onlyCollegeProfileMaintainer())
                "
                >Profile Views- {{ college.views }}</a-button
              >
              <div
                v-if="$route.params.id && $route.params.id !== localCollegeId"
                class="fav-click"
                @click="changeFav"
                :class="{ isfav: checkedFavourite.isFav }"
              >
                <a-icon type="heart" class="outline" theme="outlined" />
                <a-icon type="heart" class="fill" theme="filled" />
              </div>
            </div>
          </div>
        </div>
        <!-- content -->
        <div class="content">
          <Sliders
            :logo-image="generateImageUrl(college.logo)"
            :slider-images="
              college.background &&
              college.background.map((item) => generateImageUrl(item))
            "
            :social="{
              facebook: college.facebook,
              twitter: college.twitter,
              instagram: college.instagram,
              linkedin: college.linkedin,
              flickr: college.flickr,
              youtube: college.youtube,
              podcast: college.podcast,
            }"
          />
          <div class="tab-section">
            <a-tabs
              default-active-key="1"
              tab-position="left"
              class="summary-basic-tabs"
            >
              <a-tab-pane key="1" tab="College Details">
                <a-row :gutter="24">
                  <a-col :lg="12">
                    <div class="box">
                      <div class="box-header height-unset">
                        <h2 class="box-title">Basic information</h2>
                      </div>
                      <div class="box-body">
                        <table class="table table-striped">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th scope="row">Name:</th>
                              <td>{{ college.collegeName }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Phone</th>
                              <td>{{ college.collegePhone }}</td>
                            </tr>
                            <tr>
                              <th scope="row">College Website:</th>
                              <td class="break-all">
                                <a :href="collegeLink" target="_blank">{{
                                  college.url
                                }}</a>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Softball Website:</th>
                              <td class="break-all">
                                <a :href="softballLink" target="_blank"
                                  >{{ college.url1 }}
                                </a>
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">GPA Required:</th>
                              <td>{{ college.gpaRequired }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Division :</th>
                              <td>{{ college.division }}</td>
                            </tr>
                            <tr>
                              <th scope="row">Address :</th>
                              <td>{{ college.address1 }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </a-col>
                  <a-col :lg="12">
                    <div class="box">
                      <div class="box-header height-unset">
                        <h2 class="box-title">More Information</h2>
                      </div>
                      <div class="box-body">
                        <table class="table table-striped">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th scope="row">School Type:</th>
                              <td>
                                {{
                                  college.schoolType ? college.schoolType : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">School Education Type</th>
                              <td>
                                {{
                                  college.schoolEducationType
                                    ? college.schoolEducationType
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">College Setting:</th>
                              <td>
                                {{
                                  college.collegeSetting
                                    ? college.collegeSetting
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Enrollment:</th>
                              <td>
                                {{
                                  college.schoolEnrollment
                                    ? college.schoolEnrollment.toLocaleString()
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">Tution Fee:</th>
                              <td>
                                {{
                                  college.schoolTuition
                                    ? `$ ${college.schoolTuition.toLocaleString()}`
                                    : "-"
                                }}
                              </td>
                            </tr>
                            <tr>
                              <th scope="row">City/State/Zip:</th>
                              <td>
                                {{ college.city ? college.city : "-" }} /{{
                                  college.state ? college.state : "-"
                                }}
                                /{{ college.zip }}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="2" tab="Description">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Description</h2>
                      </div>
                      <div class="box-body">
                        <p class="w-space-preline">
                          {{ college.description }}
                        </p>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <!-- <a-tab-pane key="3" tab="Academic Specialities">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Academic Specialities</h2>
                      </div>
                      <div class="box-body">
                        <a-tag
                          v-for="(item, index) in college.academicSpecialities"
                          :key="index"
                          color="volcano"
                          >{{ item.name }}</a-tag
                        >
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane> -->
              <a-tab-pane key="4" tab="Additional Details">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Additional Details</h2>
                      </div>
                      <div class="box-body">
                        <table class="table table-striped">
                          <thead></thead>
                          <tbody>
                            <tr>
                              <th scope="row">Conference</th>
                              <td>{{ college.conference }}</td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </a-col>
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Additional Info</h2>
                      </div>
                      <div class="box-body">
                        <p class="w-space-preline">
                          {{ college.info }}
                        </p>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="5" tab="Scholorship Requirements">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Scholorship Requirements</h2>
                      </div>
                      <div class="box-body">
                        <p class="w-space-preline">
                          {{ college.scholarshipRequirement }}
                        </p>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
              <a-tab-pane key="6" tab="Team Highlights">
                <a-row :gutter="24">
                  <a-col :sm="24">
                    <div class="box">
                      <div class="box-header">
                        <h2 class="box-title">Team Highlights</h2>
                      </div>
                      <div
                        class="box-body"
                        v-if="_.isEmpty(collegeTeamHighlightsLimited)"
                      >
                        <BaseEmpty />
                      </div>
                      <div
                        class="box-body box-body-1"
                        v-else
                        v-match-heights="{
                          el: ['.image', '.box-body-1'],
                          disabled: [575],
                        }"
                      >
                        <a-row :gutter="24">
                          <a-col
                            :sm="8"
                            v-for="(
                              item, index
                            ) in collegeTeamHighlightsLimited"
                            :key="index"
                          >
                            <figure class="thumbnail text-center">
                              <a
                                class="font-weight-bold"
                                @click="
                                  goToRoute(
                                    `/${profileId}/college_profile/team_highlights/${item.Id}/show/${item.collegeId.id}`
                                  )
                                "
                              >
                                <img
                                  class="image"
                                  :src="generateImageUrl(item.image)"
                                />
                                <figcaption>
                                  {{ item.title }}
                                </figcaption>
                              </a>
                            </figure>
                          </a-col>
                        </a-row>
                      </div>
                      <div
                        class="highlights-footer text-center"
                        v-if="!_.isEmpty(collegeTeamHighlightsLimited)"
                      >
                        <div
                          class="button-wrapper"
                          style="padding-bottom: 15px"
                        >
                          <a-button
                            type="primary"
                            @click="
                              goToRoute(
                                $route.params.id
                                  ? `/${profileId}/college_profile/${$route.params.id}/team_highlights`
                                  : `/${profileId}/college_profile/team_highlights`
                              )
                            "
                          >
                            View More
                            <i
                              class="fa fa-angle-double-right"
                              aria-hidden="true"
                              style="margin-left: 10px; color: #fff"
                            ></i>
                          </a-button>
                        </div>
                      </div>
                    </div>
                  </a-col>
                </a-row>
              </a-tab-pane>
            </a-tabs>
          </div>
          <!-- /.content -->
        </div>
        <!-- /.page-wrapper -->
      </div>
      <!-- /.container -->
      <!-- Sections  coaching-team-->
      <section class="coaching-team content">
        <div class="container">
          <div class="main-heading text-center">
            <h2>Coaching Staff</h2>
            <p v-if="_.isEmpty(filteredCoaches)">No Data Available !</p>
            <p
              class="notice-color-red"
              v-if="
                !this.$route.params.id &&
                (onlyCollegeHeadCoach() || onlyCollegeProfileMaintainer())
              "
            >
              If the displayed order of your Coaching Staff needs to be
              adjusted, please contact admin
            </p>
          </div>
          <a-row :gutter="24">
            <a-col
              :sm="12"
              :lg="8"
              v-for="(coach, index) in filteredCoaches"
              :key="index"
            >
              <div
                class="section box"
                v-match-heights="{
                  el: ['.company-content', '.box .box-header', '.event-footer'],
                  disabled: [575],
                }"
              >
                <div class="box-header d-flex-spc-btwn">
                  <span class="box-title">{{ coach.coachname }}</span>
                  <a-dropdown
                    v-if="canComplain && coach.lastLogin"
                    placement="bottomRight"
                    :trigger="['click']"
                  >
                    <a-icon class="padding-top-1 pointer-hover" type="more" />
                    <a-menu slot="overlay">
                      <a-menu-item>
                        <a @click="reportCoach(coach)">Report Coach</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </div>
                <div class="box-body">
                  <!-- event-box -->
                  <div class="event-box">
                    <div class="company-content">
                      <!-- Left-aligned media object -->
                      <div class="media">
                        <div class="main-heading">
                          <h2>{{ coach.position }}</h2>
                        </div>
                        <div class="media-body">
                          <div class="media-left">
                            <img
                              :src="generateImageUrl(coach.profileImage)"
                              class="media-object"
                            />
                          </div>
                          <div class="media-description">
                            <p class="w-space-preline">
                              {{ coach.description }}
                            </p>
                            <span style="font-weight: 700">
                              <a
                                class="color-secondary"
                                @click="
                                  goToRoute(
                                    `/${profileId}/college_profile/coaching_staffs/${coach.coachId}/details`
                                  )
                                "
                                >FULL BIO</a
                              >
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                    <!-- /.company-content -->
                    <div class="event-footer">
                      <button
                        v-if="
                          coach.lastLogin &&
                          coach.id !== profileId &&
                          !coachIsDeactivated(coach)
                        "
                        type="button"
                        class="btn btn-default"
                        @click="handleConnect(coach.id, coach.uniqueSlug)"
                      >
                        {{ coach.isConnected ? "Message" : "Connect" }}
                      </button>

                      <div
                        v-else-if="coach.lastLogin && coachIsDeactivated(coach)"
                      >
                        <p
                          class="chat-connect-info"
                          v-if="coach.contactIsIgnored"
                        >
                          You have ignored this user. Go to your ignored list
                          and chat with this user.
                        </p>
                        <p
                          class="chat-connect-info"
                          v-else-if="coach.isContactSaved"
                        >
                          You have saved this user. Go to your saved list and
                          chat with this user.
                        </p>
                        <p class="chat-connect-info" v-else>
                          You have blocked this user. Go to your chat screen and
                          unblock this user first.
                        </p>
                      </div>

                      <div v-else-if="!coach.lastLogin">
                        <button
                          type="primary"
                          class="btn btn-default"
                          @click="
                            handleCoachMail(
                              coach.email,
                              coach.name,
                              coach.coachId
                            )
                          "
                        >
                          {{
                            requestedIds.includes(coach.coachId)
                              ? "FOLLOW UP EMAIL"
                              : "SEND AN EMAIL"
                          }}
                          <!-- <i
                          class="fa fa-envelope"
                          @click="
                            handleCoachMail(coach.email, coach.name, coach.id)
                          "
                        ></i> -->
                        </button>
                        <a-tooltip class="margin-l-1">
                          <template slot="title">{{
                            getTooltipText(requestedIds.includes(coach.coachId))
                          }}</template>
                          <BaseIcon :size="30" type="info-circle" />
                        </a-tooltip>
                      </div>
                    </div>
                  </div>
                  <!-- /.event-box -->
                </div>
                <!-- /.box-body -->
              </div>
            </a-col>
          </a-row>
        </div>
      </section>
      <!-- /.sections  /.coaching-team-->
      <Videos
        :video-data="limitedVideos"
        @view-all="
          goToRoute(
            $route.params.id
              ? `/${profileId}/college_profile/${$route.params.id}/listing/videos`
              : `/${profileId}/college_profile/listing/videos`
          )
        "
      />
      <!-- Sections  latest-video-->
      <Events
      title="Upcoming Team Events"
        :event-data="collegeTeamEvents"
        :participatingEvents="collegeTeamEvents"
        @view-all="
          goToRoute(
            $route.params.id
              ? `/${profileId}/college_profile/${$route.params.id}/events`
              : `/${profileId}/college/events`
          )
        "
        type="college"
      />
            <Events
      title="Upcoming Promoted Events"
        :event-data="collegeEventsLimited"
        :participatingEvents="collegeEventsLimited"
        @view-all="
          goToRoute(
            $route.params.id
              ? `/${profileId}/college_profile/${$route.params.id}/events`
              : `/${profileId}/college/events`
          )
        "
        type="college"
      />
    </div>
  </div>
</template>
<script>
import Sliders from "@/views/commonprofile/slider";
import Videos from "@/views/commonprofile/video";
import Events from "@/views/commonprofile/event";
import { mapGetters } from "vuex";
import { Chat } from "@/models";

const STORE_KEY = "collegeStore";
const HIGHLIGHT_STORE_KEY = "collegeTeamHighlightStore";
const COACH_STORE_KEY = "coachStore";
const EVENT_STORE_KEY = "collegeEventStore";
const CHAT_STORE_KEY = "chatStore";
const ATHLETE_STORE_KEY = "athleteStore";
const FAVOURITE_STORE_KEY = "favouriteStore";

export default {
  name: "Summary",
  components: {
    Sliders,
    Videos,
    Events,
  },
  computed: {
    ...mapGetters({
      college: `${STORE_KEY}/college`,
      collegeTeamHighlightsLimited: `${HIGHLIGHT_STORE_KEY}/collegeTeamHighlightsLimited`,
      coaches: `${COACH_STORE_KEY}/coaches`,
      collegeEventsLimited: `${EVENT_STORE_KEY}/collegeEvents`,
      collegeTeamEvents: `${EVENT_STORE_KEY}/collegeTeamEvents`,
      limitedVideos: `${STORE_KEY}/limitedVideos`,
      checkedFavourite: `${FAVOURITE_STORE_KEY}/checkedFavourite`,
      singleCoach: `${COACH_STORE_KEY}/singleCoach`,
      athlete: `${ATHLETE_STORE_KEY}/athlete`,
    }),
    collegeId() {
      return this.$route.params.id || localStorage["college-id"];
    },
    localCollegeId() {
      return localStorage["college-id"];
    },
    requestedIds() {
      return (
        this.athlete.requestedCoachIds ||
        this.singleCoach.requestedCoachIds ||
        []
      );
    },
    profileId() {
      return Chat.profileId();
    },
    canComplain() {
      return (
        this.exceptBasicPlayer && Chat.userType().toLowerCase() === "athlete"
      );
    },
    softballLink() {
      try {
        let url = new URL(this.college.url1);
        return this.college.url1;
      } catch (err) {
        return `https://${this.college.url1}`;
      }
    },
    collegeLink() {
      try {
        let url = new URL(this.college.url);
        return this.college.url;
      } catch {
        return `https://${this.college.url}`;
      }
    },
    currentDate() {
      const currentDate = new Date();
      const month = `0${currentDate.getMonth() + 1}`;
      return `${currentDate.getFullYear()}/${
        month.length === 2
          ? month
          : `${month.split("")[1]}${month.split("")[2]}`
      }/${currentDate.getDate()}`;
    },
    filteredCoaches() {
      return this.coaches.filter((coach) => coach.isActive);
    },
    
  },
  mounted() {
    this.$store.dispatch(`${STORE_KEY}/getCollege`, {
      id: this.collegeId,
    });
    this.$store.dispatch(
      `${HIGHLIGHT_STORE_KEY}/getCollegeTeamHighlightsLimited`,
      {
        id: this.collegeId,
        limit: 3,
      }
    );
    this.$store.dispatch(`${COACH_STORE_KEY}/getCoaches`, {
      CollegeId: this.collegeId,
      sort: "createdAt",
      fields:
        "coachname,position,role,description,profileImage,uniqueSlug,isDeleted,isActive",
    });
    this.$store.dispatch(`${STORE_KEY}/getLimitedVideos`, {
      id: this.collegeId,
      limit: 3,
    });
    this.$store.dispatch(`${EVENT_STORE_KEY}/getCollegeEventsV1`, {
      collegeId: this.collegeId,
      limit: 4,
      "date[gte]": this.currentDate,
      sort: "date",
      displayOnProfile:false
    });
    this.$store.dispatch(`${EVENT_STORE_KEY}/getCollegeEventsV2`, {
      collegeId: this.collegeId,
      limit: 4,
      "date[gte]": this.currentDate,
      sort: "date",
      displayOnProfile:true

    });
    this.$store.dispatch(`${FAVOURITE_STORE_KEY}/checkFavourite`, {
      id: this.collegeId,
    });
  },
  methods: {
    async changeFav() {
      if (this.checkedFavourite.isFav) {
        await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/deleteFavourite`, {
          favBy: Chat.profileId(),
          favTo: this.collegeId,
        });
        this.$store.dispatch(`${FAVOURITE_STORE_KEY}/unsetCheckedFavourite`);
        return;
      }
      await this.$store.dispatch(`${FAVOURITE_STORE_KEY}/createFavourite`, {
        favBy: Chat.profileId(),
        favTo: this.collegeId,
        typeFav: "college",
      });
      this.$store.dispatch(`${FAVOURITE_STORE_KEY}/setCheckedFavourite`);
    },
    reportCoach(coach) {
      let route = `/${this.profileId}/complain`;
      sessionStorage["coach-id"] = coach.id;
      sessionStorage["coach-type"] = coach.uniqueSlug;
      sessionStorage["coach-name"] = coach.name;
      this.$router.push({
        path: route,
      });
    },
    getTooltipText(value) {
      return value
        ? "You have already sent an email to this coach. Try sending follow up email from here"
        : "This coach is not available for chat right now, try sending an email from here";
    },
    goToRoute(route) {
      this.$router.push(route);
    },
    handleCoachMail(emailAddress, coachName, coachId) {
      sessionStorage["coach-id"] = coachId;
      let route = `/${this.profileId}/send-mail-to-coach`;
      this.$router.push({
        path: route,
      });
    },
    handleConnect(coachId, coachType) {
      const receiverInfo = btoa(
        JSON.stringify({
          receiver_id: coachId,
          receiver_type: Chat.receiverType(coachType),
        })
      );
      this.$router.push({
        path: `/${this.profileId}/chat/${receiverInfo}`,
      });
    },
    coachIsDeactivated(coach) {
      return (
        (coach.isConnected && coach.contactIsIgnored) ||
        (coach.isConnected && coach.contactIsBlocked) ||
        (coach.isConnected && coach.isContactSaved)
      );
    },
  },
};
</script>

<style lang="scss">
.notice-color-red {
  color: #d87612;
  font-weight: bolder;
  font-size: 1.1rem;
}
.summary-basic-tabs {
  .ant-tabs-nav {
    .ant-tabs-tab {
      display: block !important;
    }
  }
}
.chat-connect-info {
  font-weight: 500;
  margin-bottom: 0 !important;
  color: #ff4f49;
}
.coaching-team {
  width: 100%;
  background: #f0f0f0;
  padding: 60px 0;
  color: #000000;
  .box {
    max-width: 350px;
    margin: 0 auto;
  }
  .box-header {
    padding: 10px 15px !important;
    font-size: 22px;
    font-weight: 700;
    text-transform: uppercase;
  }
  .main-heading {
    h1 {
      border: none;
    }
    h2 {
      font-size: 18px;
      text-transform: uppercase;
      font-weight: 700;
    }
  }
  .media-body {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    justify-content: space-between;
    width: 100%;
    .media-left {
      width: 105px;
      height: 115px;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border: 1px solid #ccc;
      }
    }
    .media-description {
      width: calc(100% - 120px);
      p {
        font-size: 14px;
        line-height: 22px;
        margin-bottom: 5px !important;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        -webkit-box-orient: vertical;
        overflow: hidden;
      }
    }
  }
}

@media only screen and (max-width: 767px) {
  .coaching-team {
    .box-header {
      font-size: 20px;
    }
  }
}
</style>
